<template>
  <a href="#app" class="sr-only focus:not-sr-only">{{ $t('skip-nav') }}</a>
  <nav class="h-80 md:hidden bg-white" @keydown.esc="handleEsc()">
    <div class="flex items-center justify-between h-full">
      <div class="bg-animation z-20 w-full h-full border-t-6 bg-white">
        <div class="page-container flex justify-center items-center h-full">
          <a href="/" :title="$t('front-page')" :aria-label="$t('front-page')">
            <honk-logo class="h-40 w-40" />
          </a>
          <span class="space-x-16 absolute right-16">
            <hamburger-icon ref="menu" @toggle="menuIsOpen = !menuIsOpen" />
          </span>
        </div>
      </div>
      <div
        class="absolute w-full z-10 top-0 h-auto menu-animation max-h-screen overflow-scroll bg-white"
        :class="{ open: menuIsOpen, close: !menuIsOpen }"
      >
        <div class="page-container flex flex-col md:flex-row mt-80 md:justify-between items-center">
          <div class="flex flex-col items-center md:items-start my-44 gap-24">
            <a href="/cars" class="h1 no-underline font-moret">
              {{ $t('see-cars') }}
            </a>
            <a href="/campaigns" class="h1 no-underline font-moret">
              {{ $t('campaigns') }}
            </a>
            <a href="/contact" class="h3 no-underline my-40">
              {{ $t('customer-service') }}
            </a>
            <div class="flex justify-center md:justify-start">
              <f-button v-if="isLoggedIn" primary @click="handleLogout">{{ $t('log-out') }}</f-button>
              <f-button v-else primary @click="handleLogin">
                {{ $t('log-in') }}
              </f-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <nav class="h-80 hidden md:flex bg-white border-t-6">
    <div class="w-full bg-white z-20">
      <div class="flex page-container-large page-container justify-between items-center h-full">
        <div class="flex items-center gap-24">
          <a href="/" :title="$t('front-page')" :aria-label="$t('front-page')">
            <honk-logo class="h-40 w-40" />
          </a>
          <a href="/cars" class="no-underline font-bold">
            {{ $t('see-cars') }}
          </a>
          <a href="/campaigns" class="no-underline font-bold">
            {{ $t('campaigns') }}
          </a>
        </div>
        <div class="flex justify-end items-center gap-24">
          <a href="/contact" class="no-underline font-bold">
            {{ $t('customer-service') }}
          </a>
          <div class="flex justify-center md:justify-start">
            <f-button v-if="isLoggedIn" class="p-0 text-16 font-bold" link @click="handleLogout">{{ $t('log-out') }}</f-button>
            <f-button v-else class="p-0 text-16 font-bold" link @click="handleLogin">
              {{ $t('log-in') }}
            </f-button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
  /* eslint-disable no-console */
  import { ref } from 'vue'
  import HamburgerIcon from './components/HamburgerIcon.vue'
  import HonkLogo from './components/HonkLogo.vue'
  import { useAccount } from './account/index.js'

  const menuIsOpen = ref(false)
  const menu = ref(false)

  const { login, logout, isLoggedIn } = useAccount()

  const handleLogin = async () => {
    try {
      await login()
    } catch (err) {
      console.error('Login failed', err)
    }
  }

  const handleLogout = async () => {
    try {
      await logout()
    } catch (err) {
      console.error('Logout failed', err)
    }
  }
  const handleEsc = () => {
    menu.value.handleEsc()
  }
</script>
<style scoped>
  .border-t-6 {
    border-top: 6px solid #57db09;
  }
  .close {
    transform: translateY(-100%);
    visibility: hidden;
  }
  .open {
    transform: translateY(0);
    visibility: visible;
  }
  .menu-animation {
    transition: all 0.4s ease;
  }
  /* 705 */
  .h-80 {
    height: 80px;
  }
  .bg-animation {
    transition: background-color 0.2s ease;
  }
  .page-container-large {
    max-width: 1280px !important;
    padding: 0 16px !important;
  }
  @media (min-width: 1281px) {
    .page-container-large {
      padding: 0 !important;
    }
  }

  @media (min-width: 990px) {
    .page-container-large {
      max-width: 990px;
    }
  }
  .font-moret {
    font-family: moret;
  }
</style>
